import { LegacyDevice } from './device';
export default class {
    _ui;
    _selectedDevice;
    _deviceEventListenerBound;
    _devices;
    _device_by_id;
    constructor(ui, json, selected_device_id) {
        this._ui = ui;
        this._deviceEventListenerBound = this._deviceWildcardListener.bind(this);
        this._ui.comet.listen({
            event: 'created',
            callback: (msg) => {
                const dev = new LegacyDevice(this._ui, msg);
                this.add(dev);
                this.selectedDevice(dev);
            },
        });
        this._ui.comet.listen({
            event: 'deleted',
            callback: (msg) => {
                const device = this._device_by_id[msg.device_id];
                if (device)
                    this.remove(device);
            },
        });
        this._devices = [];
        this._device_by_id = {};
        if (json)
            this.parseJSON(json);
        if (window.location.hash) {
            const hash_dev_type = window.location.hash.substr(1).replace(/_/g, ' ');
            // @ts-ignore
            this.each((dev) => {
                if (dev.device_type() && dev.device_type().name == hash_dev_type) {
                    selected_device_id = dev.id();
                    return false;
                }
            });
        }
        if (selected_device_id && this.device(selected_device_id))
            this.selectedDevice(this.device(selected_device_id));
    }
    destroy() {
        // for (var i in this._devices)
        // if (this._devices.hasOwnProperty(i))
        for (let i = 0; i < this._devices.length; i++)
            this._devices[i].destroy();
        this._devices = [];
        delete this._device_by_id;
    }
    parseJSON(json) {
        const json_ids = {};
        for (let i = 0; i < json.length; i++) {
            // @ts-ignore
            json_ids[json[i].id] = true;
            let device = this.device(json[i].id);
            if (device)
                device.set(json[i]);
            else {
                device = new LegacyDevice(this._ui, json[i]);
                this.add(device, false);
            }
            if ('io' in json[i])
                device.setIOValues(json[i].io);
        }
        // for (var i in this._devices)
        //     if (this._devices.hasOwnProperty(i))
        //         if (! json_ids[i])
        //             this.remove(this._devices[i])
        const unwanted = [];
        for (let i = 0; i < this._devices.length; i++)
            if (!json_ids.hasOwnProperty(this._devices[i].id()))
                unwanted.push(this._devices[i]);
        for (let i = 0; i < unwanted.length; i++)
            this.remove(unwanted[i]);
    }
    add(device, saveselected) {
        this._devices.push(device);
        this._device_by_id[device.id()] = device;
        device.bindWildcard(this._deviceEventListenerBound);
        this.notify('added', [device]);
        if (this._selectedDevice == null) {
            this.selectedDevice(device);
            if (saveselected &&
                device &&
                this._ui.settings &&
                this._ui.settings.data().selected_device_id != device.id())
                this._ui.settings.set({
                    selected_device_id: device ? device.id() : 0,
                });
        }
    }
    remove(device) {
        delete this._device_by_id[device.id()];
        for (let i = 0; i < this._devices.length; i++)
            if (this._devices[i].id() == device.id()) {
                this._devices.splice(i, 1);
                break;
            }
        device.unbindWildcard(this._deviceEventListenerBound);
        if (this._selectedDevice == device) {
            if (this._devices.length > 0)
                this.selectedDevice(this._devices[0]);
            else
                this.selectedDevice(null);
        }
        this.notify('removed', [device]);
    }
    device(id) {
        if (this._device_by_id.hasOwnProperty(id))
            return this._device_by_id[id];
        return null;
    }
    first() {
        return this._devices[0] || null;
    }
    each(callback) {
        // for (var i in this._devices)
        //     if (this._devices.hasOwnProperty(i))
        for (let i = 0; i < this._devices.length; i++)
            if (callback.call(this._devices[i], this._devices[i]) === false)
                break;
        return this;
    }
    allDevices() {
        // var devs = []
        // for (var i in this._devices)
        //     if (this._devices.hasOwnProperty(i))
        //         devs.push(this._devices[i])
        // return devs
        return this._devices.slice();
    }
    count() {
        // FIXME: can be solved more efficiently with Object.keys()
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
        // This way only for the sake of IE8
        // var count = 0
        // for (var i in this._devices)
        //     if (this._devices.hasOwnProperty(i))
        //         count++
        // return count
        return this._devices.length;
    }
    // update: function () {
    //     return this._ui.api.call({
    //         method: 'devices',
    //         data: {load_io: true},
    //
    //         success: (function (json, xhr) {
    //             for (var i = 0; i < this._devices.length; i++)
    //                 this._devices[i]._called_from_update = true
    //             this.parseJSON(json.devices)
    //             for (var i = 0; i < this._devices.length; i++)
    //                 this._devices[i]._called_from_update = false
    //         }).bind(this)
    //     })
    // },
    update_from_json(devices_json) {
        for (let i = 0; i < this._devices.length; i++)
            this._devices[i]._called_from_update = true;
        this.parseJSON(devices_json);
        for (let i = 0; i < this._devices.length; i++)
            this._devices[i]._called_from_update = false;
    }
    _deviceWildcardListener(device, eventname, eventargs) {
        this.notify('deviceEvent', arguments);
        if (device == this._selectedDevice)
            this.notify('selectedDeviceEvent', arguments);
    }
    $wildcardListeners;
    $listeners;
    notify(eventname, params) {
        params = params || []; // For IE8
        if (!(params instanceof Array))
            params = Array.prototype.slice.apply(params);
        if (this.$listeners && this.$listeners[eventname]) {
            const listeners = this.$listeners[eventname];
            for (let i = 0; i < listeners.length; i++)
                listeners[i].apply(this, params);
        }
        if (this.$wildcardListeners) {
            const wildcardParams = [this, eventname].concat(params);
            // for (var i in this.$wildcardListeners)
            for (let i = 0, len = this.$wildcardListeners.length; i < len; i++)
                this.$wildcardListeners[i].apply(this, wildcardParams);
        }
        // May be we will return something more interesting in future
        // for example, result of first/last listener
        return null;
    }
    selectedDevice(value) {
        if (value || value === null) {
            this._selectedDevice = value;
        }
        return this._selectedDevice;
    }
    // @ts-ignore
    bind(...args) {
        if (args.length == 2) {
            const obj = {};
            // @ts-ignore
            obj[args[0]] = args[1];
            return this.bind(obj);
        }
        return new Binding(this, args[0]);
    }
}
class Binding {
    obj;
    handlers;
    constructor(obj, handlers) {
        this.obj = obj;
        this.handlers = handlers;
        if (!obj.$listeners)
            obj.$listeners = {};
        for (const i in this.handlers) {
            if (obj.$listeners.hasOwnProperty(i))
                obj.$listeners[i].push(this.handlers[i]);
            else
                obj.$listeners[i] = [this.handlers[i]];
        }
    }
    unbind() {
        // for (var i in this.handlers)
        //     this.unbind(i, this.handlers[i]);
        delete this.obj;
        delete this.handlers;
    }
}
// .implement(Class.EventSource)
// .implement(
//     Class.Properties({
//         selectedDevice: {
//             value: null,
//             set: function (device) {
//                 if (this._selectedDevice == device) {
//                     return;
//                 }
//
//                 this._selectedDevice = device;
//
//                 this.notify('deviceSelected', [device]);
//             },
//         },
//     })
// );
